import React from 'react';

import SasktelLogoRightSVG from '../icons/SasktelLogoRightSVG';
import SasktelLogoLeftSVG from '../icons/SasktelLogoLeftSVG';

function Footer(props) {
  return (
    <footer className={'text-12 font-normal pt-0 flex-shrink ' + (props.isHamburgerToggled ? ' hidden' : '')}>
      <div className="bg-almost-black text-middle-grey h-45 lg:h-50 w-full text-left">
        <div className="pt-10 md:pt-10 pl-15 md:pl-30 lg:pl-45 mx-auto my-0 max-w-w-7xl w-full">
          <div className="flex flex-row w-full">
            <div className="flex flex-row">
              <SasktelLogoLeftSVG fill="#ffffff" viewbox="0 0 1024 240" classes="w-60 h-25 lg:w-75 lg:h-30" />
              <SasktelLogoRightSVG fill="#ffffff" height="35" width="35" viewbox="0 0 1024 700" classes="mt-3 ml-3 lg:ml-4 w-20 h-20 lg:w-25 lg:h-25" />
            </div>
            <div className="pt-5 md:pt-4 pl-5 md:pl-5 lg:pl-15 text-10 lg:text-12 font-museo font-w-300">
              &nbsp;&nbsp;&copy;&nbsp;{new Date().getFullYear()}&nbsp;SaskTel and its licensors. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
